import { toast } from "react-toastify";

const toastedErrors = new WeakSet();

const unwrapArray = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.$values)) return value.$values;
  return [];
};

const getResponseBody = (errorOrBody) =>
  errorOrBody?.response?.data ?? errorOrBody ?? {};

const getValidationMessages = (body) => {
  const validationItems = unwrapArray(body?.Errors?.ValidationException);
  return validationItems.flatMap((item) => unwrapArray(item?.Errors));
};

export const getApiErrorMessages = (errorOrBody) => {
  const body = getResponseBody(errorOrBody);
  const messages = [
    ...unwrapArray(body?.ErrorDto?.Errors),
    ...unwrapArray(body?.error?.errors),
    ...getValidationMessages(body),
    ...unwrapArray(body?.Errors),
    ...unwrapArray(body?.errors),
    ...(typeof body?.ErrorDto?.ErrorDetails === "string" ? [body.ErrorDto.ErrorDetails] : []),
    ...(typeof body?.error?.errorDetails === "string" ? [body.error.errorDetails] : []),
    ...(typeof body?.message === "string" ? [body.message] : []),
    ...(typeof body?.Message === "string" ? [body.Message] : []),
  ];

  return [...new Set(messages.filter((message) => typeof message === "string" && message.trim()))];
};

export const getApiErrorMessage = (
  errorOrBody,
  fallback = "Beklenmeyen bir hata oluştu."
) => getApiErrorMessages(errorOrBody)[0] ?? fallback;

export const isApiErrorShowable = (errorOrBody) => {
  const body = getResponseBody(errorOrBody);
  const isShow = body?.ErrorDto?.IsShow ?? body?.error?.isShow ?? body?.IsShow;
  return isShow !== false;
};

export const toastApiError = (
  errorOrBody,
  fallback = "Beklenmeyen bir hata oluştu."
) => {
  const messages = getApiErrorMessages(errorOrBody);
  const visibleMessages = messages.length > 0 ? messages : [fallback];
  const canTrack = errorOrBody !== null && typeof errorOrBody === "object";

  if (canTrack && toastedErrors.has(errorOrBody)) return visibleMessages[0];

  if (isApiErrorShowable(errorOrBody)) {
    visibleMessages.forEach((message) => toast.error(message));
    if (canTrack) toastedErrors.add(errorOrBody);
  }

  return visibleMessages[0];
};
